export default __webpack_public_path__ + "static/media/evento.62bd3a0a.png";